import React from 'react';
import PropTypes from 'prop-types';
import { formatterMoney } from 'utils/format';
import { Card } from 'ui-components/Card'
import { LineInfo } from 'ui-components/LineInfo';

export default function Payments({ payments }) {
  return (
    <Card>
      <h5>Recebimentos</h5>
      <LineInfo
        label="Total recebido"
        value={formatterMoney(payments.attributes.total)}
      />

      <LineInfo
        label="Total débitos gerados"
        value={formatterMoney(payments.attributes.total_debts)}
      />

      <LineInfo
        label="Total de créditos gerados"
        value={formatterMoney(payments.attributes.total_generated_vouchers)}
      />

      <LineInfo
        label="Total de descontos"
        value={formatterMoney(payments.attributes.total_discount)}
      />

      <LineInfo
        label="Total de créditos utilizados"
        value={formatterMoney(payments.attributes.total_used_vouchers)}
      />
    </Card>
  )
}

Payments.propTypes = {
  payments: PropTypes.objectOf(PropTypes.any).isRequired,
}
